<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div> 查看退款</div>
                <div @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask_con">
                    <div class="mask_con_head">
                        <div class="mask_con_head_font1">退款金额</div>
                        <div class="mask_con_head_font2">-{{ dataVal.data.refundmoney }}</div>
                    </div>
                    <div class="mask_con_list">
                        <div class="mask_con_item">
                            <div class="mask_con_item_l">退款时间：</div>
                            <div class="mask_con_item_r">{{ (Number(dataVal.data.refundtime) * 1000) |
                                formatTimestamp("yyyy-MM-dd hh:mm:ss") }}</div>
                        </div>
                        <div class="mask_con_item">
                            <div class="mask_con_item_l">商品：</div>
                            <div class="mask_con_item_r">{{ dataVal.data.banjiname ? dataVal.data.banjiname : '' }}
                            </div>
                        </div>
                        <div class="mask_con_item">
                            <div class="mask_con_item_l">商户全称：</div>
                            <div class="mask_con_item_r">童峰荟（湖北）科技有限公司</div>
                        </div>
                        <div class="mask_con_item">
                            <div class="mask_con_item_l">交易单号：</div>
                            <div class="mask_con_item_r">{{ dataVal.data.payno ? dataVal.data.payno : '' }}</div>
                        </div>
                        <div class="mask_con_item">
                            <div class="mask_con_item_l">支付时间：</div>
                            <div class="mask_con_item_r">{{ (Number(dataVal.data.paytime) * 1000) |
                                formatTimestamp("yyyy-MM-dd hh:mm:ss") }}</div>
                        </div>
                        <div class="mask_con_item">
                            <div class="mask_con_item_l">取消报名原因：</div>
                            <div class="mask_con_item_r">{{ dataVal.data.cancelreason }}</div>
                        </div>
                    </div>
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund">关闭弹窗</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "viewRefund",
    props: ['dataVal'],
    data() {
        return {

        };
    },
    mounted() {
    },
    methods: {
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("viewRefundCall", data);
        },
        handleSubmit() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
            }
            this.$emit("viewRefundCall", data);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {

                }
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 502px;
        border-radius: 10px;
        background: #FFF;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #C12E30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #FFF);
                font-size: 16px;
            }

            .el-icon-close {
                color: #FFF;
            }
        }

        .mask-content-body {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #FFF;
            padding: 37px 20px 20px 33px;

            .mask_con {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                .mask_con_head {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .mask_con_head_font1 {
                        height: 19px;
                        line-height: 19px;
                        color: #777;
                        font-size: 16px;
                        font-weight: 600;
                    }

                    .mask_con_head_font2 {
                        height: 36px;
                        line-height: 36px;
                        color: #000;
                        font-size: 30px;
                        font-weight: 600;
                        margin-top: 20px;
                    }
                }

                .mask_con_list {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    margin-top: 26px;

                    .mask_con_item {
                        width: 100%;
                        display: flex;
                        margin-top: 20px;

                        .mask_con_item_l {
                            width: 132px;
                            height: 19px;
                            line-height: 19px;
                            color: #00000066;
                            font-size: 16px;
                            display: flex;
                            flex-shrink: 0;
                        }

                        .mask_con_item_r {
                            flex: 1;
                            color: #000;
                            font-size: 16px;
                        }
                    }
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 197px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.90);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #EDC2C3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #B30003;
                    }
                }
            }
        }
    }
}
</style>